import React, { FC } from 'react';
import { MotifErrorMessage } from '@ey-xd/motif-react';

type ErrorMessageProps = {
    className?: string;
    message?: string;
    id?: string;
    children?: React.ReactNode;
};
const ErrorMessage: FC<ErrorMessageProps> = ({ className, id, message }: ErrorMessageProps) => (
    <MotifErrorMessage className={className} id={id}>
        {message}
    </MotifErrorMessage>
);
export default ErrorMessage;
